import Api from '../../Api'
import {
    PRODUCT_DRAFT_FETCHING,
    PRODUCT_DRAFT_FETCHING_FAILURE,
    PRODUCT_DRAFT_FETCHING_SUCCESS,
} from '../types'

export const getProductDraft = sku => dispatch => {
    dispatch({
        type: PRODUCT_DRAFT_FETCHING,
    })

    Api.getProductDraft(sku)
        .then(response => {
            dispatch({
                type: PRODUCT_DRAFT_FETCHING_SUCCESS,
                payload: response.data,
            })
        })
        .catch(error => {
            dispatch({
                type: PRODUCT_DRAFT_FETCHING_FAILURE,
                error,
            })
        })
}
